import { render, staticRenderFns } from "./drawerData.vue?vue&type=template&id=4fd4d6d1"
import script from "./drawerData.vue?vue&type=script&lang=js"
export * from "./drawerData.vue?vue&type=script&lang=js"
import style0 from "./drawerData.vue?vue&type=style&index=0&id=4fd4d6d1&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fd4d6d1')) {
      api.createRecord('4fd4d6d1', component.options)
    } else {
      api.reload('4fd4d6d1', component.options)
    }
    module.hot.accept("./drawerData.vue?vue&type=template&id=4fd4d6d1", function () {
      api.rerender('4fd4d6d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/goods/package/components/drawerData.vue"
export default component.exports